import { Box } from "@mui/material";

import type { CreateShopProgressBarProps } from "./CreateShopProgressBar.types";
import * as styles from "./CreateShopProgressBar.styles";

export function CreateShopProgressBar({ percent }: CreateShopProgressBarProps) {
  return (
    <Box sx={styles.track}>
      <Box sx={styles.fill(percent)} />
    </Box>
  );
}
